import React from "react";
import ReactDOM from 'react-dom/client';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {HashRouter} from "react-router-dom";
import {AuthProvider} from "./auth/AuthContext";

const renderApp = () => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
        <React.StrictMode>
            <AuthProvider>
                <HashRouter>
                    <App/>
                </HashRouter>
            </AuthProvider>
        </React.StrictMode>
    );
};

// Cordova.js e generat DOAR de tooling-ul Cordova (cordova build/prepare pt android/ios/browser) -
// pe build-ul web (npm start / nginx) fisierul nu exista deloc, si asta e normal.
// Verificam Content-Type inainte de a injecta scriptul: atat dev-server-ul (webpack-dev-server)
// cat si nginx raspund cu fallback SPA (text/html, uneori status 200) pentru fisiere lipsa -
// daca am injecta orbeste <script src="cordova.js">, browserul ar incerca sa execute acel HTML
// ca JS -> "Unexpected token '<'". Verificarea de Content-Type functioneaza identic pe orice
// server, indiferent cum trateaza el 404-urile.
const loadCordovaScriptIfReal = () => new Promise((resolve) => {
    fetch(`${process.env.PUBLIC_URL}/cordova.js`)
        .then((res) => {
            const contentType = res.headers.get("content-type") || "";
            if (res.ok && contentType.includes("javascript")) {
                const tag = document.createElement("script");
                tag.src = `${process.env.PUBLIC_URL}/cordova.js`;
                tag.onload = resolve;
                tag.onerror = resolve;
                document.body.appendChild(tag);
            } else {
                // fallback SPA (text/html) sau alt raspuns nevalid -> nu-i cordova.js real, ignoram
                resolve();
            }
        })
        .catch(resolve); // eroare de retea -> continuam normal, fara cordova
});

// APK / cordova run android/browser: window.cordova exista dupa incarcare -> asteptam deviceready real.
// Browser dev sau web (nginx): cordova.js nu exista -> randam direct.
loadCordovaScriptIfReal().then(() => {
    if (window.cordova) {
        document.addEventListener("deviceready", renderApp, false);
    } else {
        renderApp();
    }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
